(function () {
  'use strict';

  /* @ngdoc object
   * @name user.leads
   * @description
   *
   */
  angular
    .module('user.leads', [
      'ui.router'
    ]);
}());
